import React from 'react';
import { PictoProps } from './index';

export const PadlockClosed = (props: PictoProps) => (
  <svg
    width={props.width || '21'}
    height={props.height || '23'}
    viewBox="0 0 21 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.44434"
      y="10.6133"
      width="18"
      height="11"
      rx="2"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.44434 10.6133V6.61328C5.44434 3.85186 7.68291 1.61328 10.4443 1.61328C13.2058 1.61328 15.4443 3.85186 15.4443 6.61328V10.6133"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
